'use strict';
/**
 * @author Maxim Seredkin
 */
export default ['$rootScope', '$scope',
                function($rootScope, $scope) {
                    // инициализация
                    init();

                    // region Functions

                    function init() {
                        $rootScope.title = 'Организации';
                        $scope.filters = [];
                        $scope.filter = {
                            type: 'ALL',
                            oiv: false,
                            omsu: false,
                            coordorg: false,
                        };
                    }

                    // endregion

                    $scope.$watch('filter.type', (current) => {
                        $scope.filters = [];

                        if (angular.equals(current, 'OIV')) {
                            $scope.filters.push(`'oiv' EQ 'true'`);
                        }

                        if (angular.equals(current, 'OMSU')) {
                            $scope.filters.push(`'omsu' EQ 'true'`);
                        }

                        if (angular.equals(current, 'COORDORG')) {
                            $scope.filters.push(`'coordorg' EQ 'true'`);
                        }
                    });
                }];
